/* eslint-disable react/prop-types */
import React, { useState } from 'react';
import Upcoming from '../assets/static_images/upcoming.svg';
import Grid from '@mui/material/Unstable_Grid2';
import Typography from '@mui/material/Typography';
import avatar1 from '../assets/images/users/avatar-1.png';

import { Box } from '@mui/material';
import UserAvatarComponent from './UserAvatarComponent';
import { Button } from '@mui/material/index';
import MiniEventPost from 'pages/events/MiniEventPost';
const UpcomingList = ({ list, model, setOffset }) => {
    return (
        <Box
            sx={{
                height: 'calc(100vh - 7.5rem)',
                overflowY: 'auto',
                '&::-webkit-scrollbar': {
                    width: '6px'
                },
                '&::-webkit-scrollbar-track': {
                    backgroundColor: '#f5f5f5',
                    borderRadius: '3px'
                },
                '&::-webkit-scrollbar-thumb': {
                    backgroundColor: '#c1c1c1',
                    borderRadius: '3px',
                    '&:hover': {
                        backgroundColor: '#a8a8a8'
                    }
                }
            }}
        >
            <Box>
                <Box
                    display="flex"
                    alignItems="center"
                    gap="0.75rem"
                    sx={{
                        padding: '1rem',
                        backgroundColor: '#f8f9fa',
                        borderRadius: '12px',
                        marginBottom: '1.5rem',
                        border: '1px solid #e9ecef'
                    }}
                >
                    <Grid item display="flex" alignItems="center" justifyContent="center">
                        <img src={Upcoming} alt="icon" style={{ width: '20px', height: '20px' }} />
                    </Grid>
                    <Grid item>
                        <Typography
                            variant="h6"
                            sx={{
                                fontWeight: 600,
                                color: '#2c3e50',
                                fontSize: '1.125rem'
                            }}
                        >
                            {`Upcoming ${model.charAt(0).toUpperCase() + model.slice(1)}s`}
                        </Typography>
                    </Grid>
                </Box>
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                    {list?.length > 0 &&
                        list.map((item, index) => {
                            return <MiniEventPost key={index} item={item} model={model} />;
                        })}
                    <Box marginY="1.5rem">
                        {list.length > 5 ? (
                            <Box display="flex" justifyContent="center" mb={2}>
                                <Button
                                    variant="outlined"
                                    sx={{
                                        borderRadius: '8px',
                                        textTransform: 'none',
                                        fontWeight: 500,
                                        padding: '8px 24px',
                                        borderColor: '#1976d2',
                                        color: '#1976d2',
                                        '&:hover': {
                                            backgroundColor: '#f3f8ff',
                                            borderColor: '#1565c0'
                                        }
                                    }}
                                    onClick={() => {
                                        setOffset(0);
                                    }}
                                >
                                    View Less
                                </Button>
                            </Box>
                        ) : (
                            list.length === 5 && (
                                <Box display="flex" justifyContent="center" mb={2}>
                                    <Button
                                        variant="contained"
                                        sx={{
                                            borderRadius: '8px',
                                            textTransform: 'none',
                                            fontWeight: 500,
                                            padding: '8px 24px',
                                            backgroundColor: '#1976d2',
                                            '&:hover': {
                                                backgroundColor: '#1565c0'
                                            }
                                        }}
                                        onClick={() => {
                                            setOffset((prev) => prev + limit);
                                        }}
                                    >
                                        View More
                                    </Button>
                                </Box>
                            )
                        )}
                    </Box>
                </Box>
            </Box>
        </Box>
    );
};

export default UpcomingList;
